export const INTERNATIONAL_TABS = {
  customs: 'customs',
  taxIdentifiers: 'tax-identifiers',
  dutiesTaxes: 'duties-taxes',
  importerOfRecord: 'importer-of-record',
  tracking: 'tracking',
};

export const DEFAULT_INTERNATIONAL_TAB = INTERNATIONAL_TABS.customs;

export const DDP_OPTION = 'ddp';
export const DDU_OPTION = 'ddu';
